import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import SEOHead from "@/components/SEOHead";
import ServicesSection from "@/components/ServicesSection";
import ProcessSection from "@/components/ProcessSection";
import WhySection from "@/components/WhySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FaqSection from "@/components/FaqSection";
import FooterSection from "@/components/FooterSection";
import MobileStickyBar from "@/components/MobileStickyBar";
import UrgencyPopup from "@/components/UrgencyPopup";
import FloatingCTA from "@/components/FloatingCTA";
import ContactForm from "@/components/ContactForm";

const Index = () => {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <SEOHead
        title="ProImpact Carrosserie Genève | Tôlerie & Peinture"
        description="Expert carrosserie à Genève. Gestion sinistre assurance complète, tôlerie, peinture, débosselage PDR. Devis gratuit 24h. ☎ +41 76 638 86 55"
        canonicalPath="/"
        modifiedTime="2026-03-30"
      />
      <Header />
      <main id="main-content">
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <ProcessSection />
        <WhySection />
        <TestimonialsSection />
        <FaqSection />

        {/* GEO-optimized summary for AI search engines */}
        <section className="py-16 relative">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-6">
                L'atelier de la Rue Voltaire
              </h2>
              <div className="blog-prose">
                <p>
                  ProImpact Carrosserie est un atelier indépendant, Rue Voltaire 22 à Genève. Nous réparons toutes les marques : tôlerie, peinture en cabine avec une teinte mesurée au spectrophotomètre, débosselage sans peinture (PDR) en 1 à 3 heures, jantes en alliage et detailing avec protection céramique.
                </p>
                <p>
                  Après un sinistre, nous gérons le dossier avec votre assurance (AXA, Zurich, Allianz, Helvetia, Generali, Mobilière, Vaudoise, Baloise et les autres) : vous ne payez que votre franchise. Nous pouvons aussi venir chercher la voiture et la ramener, partout dans la région genevoise.
                </p>
                <p>
                  Devis gratuit sous 24 h : appelez le <a href="tel:+41766388655">+41 76 638 86 55</a> ou écrivez sur <a href="https://wa.me/41766388655?text=Bonjour%2C%20je%20souhaite%20un%20devis." target="_blank" rel="noopener noreferrer">WhatsApp</a>. Ouvert 7j/7.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Contact form section */}
        <section id="devis" className="py-16 bg-muted/40 relative">
          <div className="container mx-auto px-4">
            <div className="max-w-lg mx-auto mb-8">
              <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-3">
                Demander un devis gratuit
              </h2>
              <p className="text-muted-foreground text-sm">
                Remplissez le formulaire ci-dessous ou appelez-nous directement.
              </p>
            </div>
            <ContactForm />
          </div>
        </section>
      </main>
      <FooterSection />
      <MobileStickyBar />
      <FloatingCTA />
      <UrgencyPopup />
    </div>
  );
};

export default Index;
